var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mc-confirmation',{attrs:{"value":true,"title":"Batal","message":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.","hide-header":"","size":"sm"}},[_c('b-list-group',_vm._l((5),function(n){return _c('b-list-group-item',{key:n},[_vm._v("Label")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }